

import Exclamation from "../assets/orange-exclamation.svg"
import Info from "../assets/info.svg"

export default function UpdateRequired({message, displayType}) {
  return (
    <div className="tooltip-wrap">
      {displayType === "Update" ? <img src={Exclamation} alt="exlcamation" /> : <img src={Info} alt="info" />}
      <div className="tooltip-content">
        {message}
      </div>
    </div>
  )
}